import React, {
  useState,
  RefObject,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';

import { TextFieldProps, TextField } from '@mui/material';

type Props = TextFieldProps & {
  value?: any;
  handleOnChange?: (value?: string) => void;
};

export interface Ref {
  value: RefObject<any>;
}

const Input: ForwardRefRenderFunction<Ref, Props> = (
  { value, handleOnChange, ...rest },
  ref
) => {
  const [inputValue, setInputValue] = useState<any>(value || '');

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    if (handleOnChange) {
      handleOnChange(newValue);
    }
  };

  useImperativeHandle(ref, () => ({
    value: inputValue,
  }));

  useEffect(() => {
    if (value != inputValue) {
      setInputValue(value);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return <TextField value={inputValue} onChange={handleChange} {...rest} />;
};

export default forwardRef<Ref, Props>(Input);
